class productPage {
  init() {
    // easyslide crap
    $('.easyslider-container').insertAfter('#AddToCartForm')

    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname.indexOf('127.') === 0) {
      if (!$('#local-dev-product-overrides').length) {
        $('head').append('<style id="local-dev-product-overrides">.single-product--data--wrap > p { display: none !important; }</style>');
      }
    }

    $(`[data-es-handle="slide-size-chart"],
      [data-es-handle="slide-size-guide"],
      [data-es-handle="slide-kokotaulukko"],
      [data-es-handle="slide-koko-opas"],
      [data-es-handle*="tabelle"]`).each(function () {
      $(this).attr('data-es-handle', 'slide-size-chart');
      // Define the texts
      var suomiOpas = "Koko-opas";     // FI
      var englantiOpas = "Size guide";    // EN
      var saksaOpas = "Größentabelle"; // DE

      var suomiSulje = "Sulje";         // FI
      var englantiSulje = "Close";         // EN
      var saksaSulje = "Schließen";     // DE

      // Normalize locale (handles fi-FI, de-DE, etc.)
      var lang = (window.Shopify && window.Shopify.locale ? window.Shopify.locale : (navigator.language || 'en')).split('-')[0];

      // Choose text by language
      var btnText =
        lang === 'fi' ? suomiOpas :
          lang === 'de' ? saksaOpas :
            englantiOpas;

      var closeText =
        lang === 'fi' ? suomiSulje :
          lang === 'de' ? saksaSulje :
            englantiSulje;

      var t = $(this);
      var $header = $(t).find('.easyslider-header');

      // Use the variable instead of hardcoded text
      $(t).find('.easyslider-header-text').text(btnText);
      $(this).insertBefore('.large-view');

      // Create link using the variable
      var linkItem = $('<a class="size-chart--button" href="#">' + btnText + '</a>');

      if (window.innerWidth <= 767) {
        var $mobileTarget = $('.easyslider-container .easyslider-contents').first();
        if ($mobileTarget.length) {
          $mobileTarget.prepend(linkItem);
        } else {
          $(linkItem).insertAfter('#productSelect');
        }
      } else {
        $(linkItem).insertAfter('#productSelect');
      }

      var closeItem = $('<a class="size-chart--close" href="#">' + closeText + '</a>');
      var $closeTarget = $header.length ? $header : $(this);
      $(closeItem).appendTo($closeTarget).on('click', function (e) {
        e.preventDefault();
        $(t).removeClass('in');
      });

      $(linkItem).click(function (e) {
        e.preventDefault();
        $(t).toggleClass('in');
      });

      $(this).find('p').each(function () {
        if ($(this).text().trim() === '' && $(this).children().length === 0) {
          $(this).remove();
        }
      });

      $(this).find('td').each(function () {
        var cellContent = $(this).html();
        cellContent = cellContent.replaceAll('&nbsp;', '');
        $(this).html(cellContent);
      });
    });

    $(document)
      .off('keydown.sizeGuide')
      .on('keydown.sizeGuide', function (event) {
        if (event.key === 'Escape') {
          const $openGuides = $('[data-es-handle="slide-size-chart"].in, [data-es-handle="slide-size-guide"].in');
          if ($openGuides.length) {
            event.preventDefault();
            $openGuides.removeClass('in');
          }
        }
      });

    $('.easyslider-content-wrapper img').each(function () {
      if (!$(this).attr('src')) {
        $(this).remove();
      }
      $(this).on('load', function () {
        var orientation = this.naturalWidth >= this.naturalHeight ? 'landscape' : 'portrait';
        $(this).addClass(orientation);
      }).each(function () {
        if (this.complete) $(this).trigger('load');
      });
    });
    /*
    function alignSizeChart() {
      $('[data-es-handle="slide-size-chart"]').each(function(){
        let ref = $('#productSelect');
        let refPos = $('#productSelect').position();
        $(this).css({
          'top' : refPos.top + ref.outerHeight() * .5,
          'left' : refPos.left + ref.outerWidth() + 20,
        });
      });
    }
    
    alignSizeChart();
    
    $(window).on('resize', function(){
      alignSizeChart();
    });
    */

    $('br:only-child').remove();

    $('.single-product--images--indicator .total').text($('.single-product--image').length);


    $('.close--view').click(function (e) {
      e.preventDefault();
      $('html').removeClass('noscr');
      setTimeout(function () {
        $('html').scrollTop(window.prevscrtop);
        $('.large-view').removeClass('in');
      }, 30);
    });

    var imgs = $('.single-product--images .single-product--image').clone();
    $('.large-view--content').append(imgs);
    var imgs = $('.single-product--images .single-product--image');
    $(imgs).each(function (idx) {
      $(this).attr('data-idx', (idx + 1) + '/' + imgs.length);
    });
    $('.large-view--content').children().each(function (idx) {
      $(this).attr('data-idx', (idx + 1) + '/' + imgs.length);
    });

    $('.large-view--content').unbind('scroll').scroll(function () {
      $(this).children().each(function () {
        let rect = this.getBoundingClientRect();
        if (rect.top < window.innerHeight / 2 && rect.bottom > window.innerHeight / 2) {
          $('.large-view .num').attr('data-idx', $(this).attr('data-idx'));
        }
      });
    });

    $('.single-product--images .single-product--image').click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      // $('.large-view--content').empty().append($(this).clone());

      var idx = $(this).index();
      var sel = $('.large-view--content').children().eq(idx);
      var offset = window.innerWidth >= 768 ? $(sel).outerHeight() * .2 : 0;

      $('.large-view--content').scrollTop(offset + sel.position().top + $('.large-view--content').scrollTop());

      $('.large-view .num').attr('data-idx', $(this).attr('data-idx'));

      window.prevscrtop = $('html').scrollTop();

      setTimeout(function () {
        $('html').addClass('noscr');
        $('.large-view').addClass('in');
      }, 60);

      if ($(sel).find('video').length > 0) {
        $(sel).find('video').get(0).play();
      }

      /*
      window.prevscrtop = $('html').scrollTop();

      var posy = e.pageY - window.prevscrtop;
      var posx = e.pageX;

      setTimeout(function(){
        if(window.touch) {
          var scrh = $('.large-view--content').get(0).scrollHeight;
          var scrw = $('.large-view--content').get(0).scrollWidth;
          $('.large-view--content').scrollTop(scrh/2 - window.innerHeight/1.5);
          $('.large-view--content').scrollLeft(scrw/2 - window.innerWidth/2);
        } else {
          var scrh = $('.large-view--content').get(0).scrollHeight;
          var scrw = $('.large-view--content').get(0).scrollWidth;
          var prch = (posy*.5) / window.innerHeight;
          var prcw = (posx*.2) / window.innerWidth;
          $('.large-view--content').scrollTop(scrh*prch);
          $('.large-view--content').scrollLeft(scrw*prcw);
        }

        $('html').addClass('noscr');
        $('.large-view').addClass('in');
      }, 60);
      */
    });

    $('.large-view').click(function (e) {
      e.preventDefault();
      $('html').removeClass('noscr');
      setTimeout(function () {
        $('html').scrollTop(window.prevscrtop);
        $('.large-view').removeClass('in');
      }, 30);
    }).mousemove(function (e) {
      if (!window.touch) {
        /*
        var scrh = $('.large-view--content').get(0).scrollHeight;
        var prch = (e.clientY*.5) / window.innerHeight;

        var scrw = $('.large-view--content').get(0).scrollWidth;
        var prcw = (e.clientX*.2) / window.innerWidth;

        // console.log(prch, prcw);

        $('.large-view--content').scrollTop(scrh*prch);

        $('.large-view--content').scrollLeft(scrw*prcw);
        */
      }
    });

    // thumb images
    $(window).scroll(function () {
      if (window.innerWidth >= 768) {
        $('.single-product--images .single-product--image').each(function () {
          var rect = this.getBoundingClientRect();
          var st = $(this).attr('style');
          var target = $('.thumb-image[style="' + st + '"]');
          if (rect.top <= window.innerHeight * .5 && rect.bottom >= window.innerHeight * .5) {
            $(target).addClass('fd');
          } else {
            $(target).removeClass('fd');
          }
        });
      }
    });

    $('.single-product--images').scroll(function (e) {
      if (window.innerWidth <= 767) {
        $('.single-product--images .single-product--image').each(function () {
          var rect = this.getBoundingClientRect();
          if (rect.left <= window.innerWidth * .5 && rect.right >= window.innerWidth * .5) {
            var idx = $(this).index() + 1;
            $('.single-product--images--indicator .cur').text(idx);
          }
        });
        // console.log(this.scrollLeft);
      }
    });

    $('#productSelect').on('change', function () {
      var id = $(this).val();
      var seltext = $(this).children('[value="' + id + '"]').text().trim();
      $('.ajaxified-cart-feedback').hide(200);
      console.log(seltext);
      requestAnimationFrame(function () {
        if (seltext.indexOf('notify') > -1 || seltext.indexOf('ilmoit') > -1) {
          $('#AddToCart').attr('disabled', 'disabled');
          // var leftOffset = window.innerWidth < 768 ? 32 : 16;
          // var left = $('#productSelect').outerWidth() + leftOffset;
          // $('#SI_trigger').css('left', left);
          $('#SI_trigger').css({
            'width': $('#AddToCart').outerWidth(),
            'height': $('#AddToCart').outerHeight(),
          });
          if (window.innerWidth < 768) {
            // $('#SI_trigger').css({
            //   'top' : $('#AddToCart').position().top
            // });
          }
          $('#SI_trigger').addClass('in');
        } else {
          $('#AddToCart').removeAttr('disabled');
          $('#SI_trigger').removeClass('in');
        }
      });
    });

    $(window).on('load', function () {
      $('.thumb-image').first().addClass('fd');
    });

    $('.thumb-image').unbind('click').click(function (e) {
      e.preventDefault();
      var st = $(this).attr('style');
      var target = $('.single-product--image[style="' + st + '"]');
      var pos = $(target).offset().top;
      $('html, body').animate({ 'scrollTop': pos }, 400);
    });

    $('.product-recommendations').each(function () {
      var $container = $(this);
      var baseUrl = $container.data('baseUrl');
      var productId = $container.data('productId');
      var limit = $container.data('limit');
      var productRecommendationsUrlAndContainerClass = baseUrl + '?section_id=product-recommendations&limit=' + limit +
        '&product_id=' + productId +
        ' .product-recommendations';
      $container.parent().load(productRecommendationsUrlAndContainerClass, function () {
        $('.product-item--images').unbind('mousemove mouseleave').on('mousemove', function (e) {
          var l = e.offsetX;
          var w = this.getBoundingClientRect().width;
          var prc = l / w;
          var imglen = $(this).children().length;
          var sel = Math.floor(prc * imglen);
          var selimg = $(this).children().eq(sel);
          $(this).children().removeClass('hov');
          $(selimg).addClass('hov');
        }).on('mouseleave', function () {
          $(this).children().removeClass('hov');
        });
      });
    });
  }
}

export default productPage;
